// CNIL Recommendation 2022-100 password-only policy. Keep synchronized with PasswordPolicyService.
export const MIN_LENGTH = 12;
export const MAX_LENGTH = 72;
export const MAX_UTF8_BYTES = 72;
export const ALLOWED_SPECIAL_CHARACTERS = ` !"#$%&'()*+,-./:;<=>?@[\\]^_\`{|}~€£§µ°`;
const MIN_CATEGORIES = 4;

export function utf8Length(password) {
	return new TextEncoder().encode(password).length;
}

export function containsControlCharacter(password) {
	return /[\u0000-\u001f\u007f-\u009f]/u.test(password);
}

export const PASSWORD_RULES = [
	{
		id:        'length',
		label:     `Entre ${MIN_LENGTH} et ${MAX_LENGTH} caractères`,
		mandatory: true,
		test:      p => p.length >= MIN_LENGTH && p.length <= MAX_LENGTH,
	},
	{
		id:        'bytes',
		label:     `Au maximum ${MAX_UTF8_BYTES} octets UTF-8 (limite temporaire BCrypt)`,
		mandatory: true,
		test:      p => utf8Length(p) <= MAX_UTF8_BYTES,
	},
	{
		id:        'controls',
		label:     'Aucun caractère de contrôle',
		mandatory: true,
		test:      p => !containsControlCharacter(p),
	},
	{
		id:        'uppercase',
		label:     'Lettre majuscule (A-Z)',
		mandatory: false,
		test:      p => /[A-Z]/.test(p),
	},
	{
		id:        'lowercase',
		label:     'Lettre minuscule (a-z)',
		mandatory: false,
		test:      p => /[a-z]/.test(p),
	},
	{
		id:        'digit',
		label:     'Chiffre (0-9)',
		mandatory: false,
		test:      p => /[0-9]/.test(p),
	},
	{
		id:        'special',
		label:     'Caractère spécial autorisé',
		mandatory: false,
		test:      p => [...p].some(character => ALLOWED_SPECIAL_CHARACTERS.includes(character)),
	},
];

/**
 * Validates a password against the browser-side mirror of the server policy.
 */
export function validatePassword(password) {
	const mandatoryRules = PASSWORD_RULES.filter(r => r.mandatory);
	const mandatoryResults = mandatoryRules.map(r => ({ label: r.label, ok: r.test(password) }));
	const categoryRules = PASSWORD_RULES.filter(r => !r.mandatory);
	const catResults = categoryRules.map(r => ({ label: r.label, ok: r.test(password) }));
	const catPassed = catResults.filter(r => r.ok).length;
	const missing = catResults.filter(r => !r.ok).map(r => r.label);

	const mandatoryPassed = mandatoryResults.filter(r => r.ok).length;
	const passed = mandatoryPassed + catPassed;
	const failures = mandatoryResults.filter(r => !r.ok).map(r => r.label);
	if (catPassed < MIN_CATEGORIES) {
		const needed = MIN_CATEGORIES - catPassed;
		failures.push(`${needed} catégorie(s) manquante(s) parmi : ${missing.join(', ')}`);
	}

	return {
		passed,
		total: PASSWORD_RULES.length,
		failures,
		ok: mandatoryPassed === mandatoryRules.length && catPassed >= MIN_CATEGORIES,
	};
}
